module.exports = __webpack_public_path__ + "img/Grrr.32c06290.svg";